import styled from 'styled-components'

export const KnowledgeCenterBoxWrapper = styled.div`
    text-align: center;
    width: 100%;

    .ugly-girl {
        height: 700px;
        width: auto;
        @media only screen and (max-width: 1600px) {
            height: 760px;
            width: auto;
        }
        @media only screen and (max-width: 768px) {
            display: none;
        }
    }
`